import { Divider as MuiDivider, useTheme, alpha } from '@mui/material';
import { DividerProps } from './Divider.types';

export default function Divider({ dashed, children, ...props }: DividerProps) {
  const theme = useTheme();
  return (
    <MuiDivider
      {...props}
      sx={{
        ...props.sx,
        borderStyle: dashed ? 'dashed' : 'solid',
        '&::before': {
          borderTop: `thin ${dashed ? 'dashed' : 'solid'} ${alpha(
            theme.palette.grey[500],
            0.32,
          )}`,
        },
        '&::after': {
          borderTop: `thin ${dashed ? 'dashed' : 'solid'} ${alpha(
            theme.palette.grey[500],
            0.32,
          )}`,
        },
      }}
    >
      {children}
    </MuiDivider>
  );
}
